module.exports = __webpack_public_path__ + "img/boat-rodeo.81aa7d92.png";